<template>
  <div v-if="isOpen" class="container">
    <div class="dialog">
      <div class="dialog-child">
        <div class="text">{{ text }}</div>
        <div class="btn__container">
          <button @click="$emit('confirm')">Да</button>
          <button @click="$emit('cancel')">Не</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    text: String
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: fixed;
  top: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(255, 255, 255, 0.75);
}
.dialog {
  top: 50%;
  position: fixed;
  background: rgb(70, 70, 70);
  border-radius: 12px;
  left: 50%;
  width: 50%;
  height: 50%;
  transform: translate(-50%, -50%);
}
.dialog-child {
  top: 50%;
  position: fixed;
  background: rgb(255, 102, 0);
  left: 50%;
  width: 70%;
  height: 70%;
  transform: translate(-50%, -50%);
}
.btn__container {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}
.text {
  font-size: 2rem;
  padding: 2rem;
  text-align: center;
  color: #fff;
}
button {
  padding: 1rem 3rem;
  margin: 1.5rem;
  border: 0;
  background: rgb(0, 0, 0);
  border-radius: 4px;
  color: #fff;
}

@media (max-width: 768px) {
  .dialog {
    top: 40%;
    width: 80%;
    &-child {
      width: 80%;
    }
  }
}
</style>
